module.exports = __webpack_public_path__ + "static/media/icono_normativas.4d4f74c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_normativas.png
// module id = 813
// module chunks = 0